import * as React from 'react';
import { createComponent } from '@lit/react';
import { NoProjectAccessWC } from './no-project-access.wc';
import {
  GenerateComponentTypeWithChildren,
  GeneratePropsWithRef,
} from '../../../components/component-types-generics';

export type NoProjectAccessProps =
  GenerateComponentTypeWithChildren<NoProjectAccessWC>;

export type NoProjectAccessPropsWithRef =
  GeneratePropsWithRef<NoProjectAccessProps>;

export const NoProjectAccess = createComponent({
  tagName: NoProjectAccessWC.tagname,
  elementClass: NoProjectAccessWC,
  react: React,
}) as NoProjectAccessPropsWithRef;
